import React, { createContext, useState } from "react";

// Create the context
export const LanguageContext = createContext();

// Create a provider
export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("EN");

  const toggleLanguage = () => {
    setLang(lang === "EN" ? "RU" : "EN");
  };

  return (
    <LanguageContext.Provider value={{ lang, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};